// ============================================
// RutaProtegida — gating de modulos por permiso
// ============================================
// PERM-3.A+B (FASE A0): envuelve cualquier modulo top-level con un check
// del JSONB usuario.permisos. Si el usuario no tiene el permiso, muestra
// pantalla "Sin acceso" en lugar del modulo.
//
// PERM-3.C: PROTECCION TRANSITORIA eliminada. Todos los usuarios tienen
// permisos minimos via migracion 016. Si alguien tiene permisos vacios
// (caso edge: usuario nuevo sin migracion aun), ahora ve "Sin acceso" en
// lugar del menu completo (deny by default).
//
// 3 estados posibles:
//   1. accesoTotal (direccion) → siempre pasa
//   2. !permisosFetched (cargando) → loader (no decide aun)
//   3. permisosFetched + chequeo estricto via puedeAcceder()
//
// FIX-GATE-FLAT (2026-07-04): el chequeo ahora usa puedeAcceder (gate unico
// de utils/permisos.js) en lugar de puede() directo. Diferencia: las
// secciones flat del sidebar (Expedientes) navegan a una clave SIN punto
// ('operaciones') que la matriz granular nunca escribe; puedeAcceder la
// resuelve como "tiene al menos un submodulo del modulo", igual que el
// sidebar. Antes, puede('operaciones') fallaba siempre para roles distintos
// de direccion aunque tuvieran todas las palomitas.

import React from 'react';
import { useUsuario } from '../context/UsuarioContext';
import { labelDePermiso } from '../utils/permisos';

export function RutaProtegida({ permiso, children, fallback }) {
  const { puedeAcceder, accesoTotal, permisosFetched } = useUsuario();

  // Direccion siempre pasa
  if (accesoTotal) return children;

  // Si los permisos AUN no se cargaron del backend, no decidir todavia.
  // Mostrar loader en lugar de "Sin acceso" prematuro o de abrir todo.
  if (!permisosFetched) {
    return (
      <div style={{ padding: 60, textAlign: 'center', fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ fontSize: 32, marginBottom: 12 }}>{'⌛'}</div>
        <p style={{ color: '#5e666e' }}>Cargando permisos...</p>
      </div>
    );
  }

  // Caso normal: tiene permisos configurados, chequear via el gate unico
  if (puedeAcceder(permiso)) return children;
  return fallback || <SinAcceso permiso={permiso} />;
}

function SinAcceso({ permiso }) {
  // Nombrar el permiso REAL que falta, en humano y en clave tecnica, para que
  // el administrador sepa exactamente que palomita marcar en Usuarios.
  const etiqueta = labelDePermiso(permiso);
  const esModulo = permiso && !String(permiso).includes('.');
  return (
    <div style={{ padding: 60, textAlign: 'center', fontFamily: "'Poppins', sans-serif" }}>
      <div style={{ fontSize: 56, marginBottom: 16 }}>🔒</div>
      <h2 style={{ color: '#270f2b', margin: '0 0 12px' }}>Sin acceso a este modulo</h2>
      {/* overflowWrap anywhere: las claves tecnicas (ej. almacen.materialinstalaciones)
          son una sola "palabra" para el navegador (el punto no quiebra linea) y
          desbordan en celular de 360px sin esto (veto Don Porfirio, ciclo 1). */}
      <p style={{ color: '#5e666e', maxWidth: 420, margin: '0 auto', lineHeight: 1.5, overflowWrap: 'anywhere' }}>
        No tienes permisos para entrar aqui. Pide al administrador del sistema
        que en la pantalla <strong>Usuarios</strong> te marque{' '}
        {esModulo ? 'algun permiso del modulo' : 'el permiso'}{' '}
        <strong>{etiqueta}</strong>{' '}
        <code style={{ background: '#f3f4f4', padding: '2px 6px', borderRadius: 4, overflowWrap: 'anywhere' }}>
          {esModulo ? `${permiso}.*` : permiso}
        </code>.
      </p>
    </div>
  );
}
